/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_FUNCTION_USER } from '../../../../hooks/enviroment'
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant'

export default async function serviceChangePassword(item, token) {
	await axios({
		method: 'POST',
		url: `${Enviroment.API_PHARMACY}/user-panel/change-password`,
		data: {
			old_password: item.old_password,
			new_password: item.new_password,
		},
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((response) => {
			console.group('response change password',response)
			if (response.data.statusCode === 201) {
				notification['success']({
					message: 'Hecho',
					description: 'Clave cambiada con exito',
				})
			} else {
				notification['error']({
					message: response.data.error,
					description: response.data.message,
				})
			}
		})
		.catch((error) => {
			notification['error']({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_USER}/user/change-password`,
			})
		})
}
